/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `TextFieldType*`'s.
 */
export type TextFieldType =
  | TextFieldTypeSingle
  | TextFieldTypeMultiline
  | TextFieldTypeTextarea
  | TextFieldTypePassword;

/**
 * The text field single type.
 */
export type TextFieldTypeSingle = typeof TEXTFIELD_TYPE_SINGLE;

/**
 * The text field multiple type.
 */
export type TextFieldTypeMultiline = typeof TEXTFIELD_TYPE_MULTIPLE;

/**
 * The text field textarea type.
 */
export type TextFieldTypeTextarea = typeof TEXTFIELD_TYPE_TEXTAREA;

/**
 * The text field password type.
 */
export type TextFieldTypePassword = typeof TEXTFIELD_TYPE_PASSWORD;

/**
 * The text field single line constant.
 */
export const TEXTFIELD_TYPE_SINGLE = `single`;

/**
 * The text field multiple line constant.
 */
export const TEXTFIELD_TYPE_MULTIPLE = `multiple`;

/**
 * The text field textarea constant.
 */
export const TEXTFIELD_TYPE_TEXTAREA = `textarea`;

/**
 * The text field password constant.
 */
export const TEXTFIELD_TYPE_PASSWORD = `password`;
